import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import AdUnit from './AdUnit';
import { getAdUnitPackage } from '../../util/adUtils';

const mapStateToProps = state => ({
  country: state.country,
  breakpoint: state.events.breakpoint,
  routeParams: state.routeParams,
});

const PanoramaAdContainer = ({country, breakpoint, routeParams}) =>
    <AdUnit // Reload the ad when changing route params
            id="panorama"
            key={_.map(routeParams).join('')}
            country={country}
            value={getAdUnitPackage(country, 'Panorama', breakpoint)} />;

export default connect(mapStateToProps)(PanoramaAdContainer);



// WEBPACK FOOTER //
// ./src/component/Ads/PanoramaAdContainer.jsx